import { usePostOfficeBottomSheetState } from '@apps/admin/postOffice/PostOffice.bottomSheet';
import { useTranslation } from '@shared/core';

export const useOptionalTestEmailViewController = () => {
  const { t } = useTranslation('postOffice');
  const tBottomSheet = t('bottomSheet');
  const tOptionalTestEmail = tBottomSheet.optionalTestEmail;
  const { parentViewState } = usePostOfficeBottomSheetState();
  const handleButtonClick = parentViewState.handleSendTestEmailDialogOpen;

  return { tOptionalTestEmail, handleButtonClick };
};
